import { useEffect, useState } from 'react';
import { getInmueblesByCliente } from '../../../services/inmuebles';
import {
	Box,
	Button,
	Flex,
	Heading,
	Spacer,
	Table,
	TableContainer,
	Tbody,
	Td,
	Th,
	Thead,
	Tr,
} from '@chakra-ui/react';
import InmuebleTableItem from './InmuebleTableItem';
import { useNavigate } from 'react-router-dom';
import { AddIcon } from '@chakra-ui/icons';

const TablaInmueblesCliente = ({ cliente }) => {
	const [inmuebles, setInmuebles] = useState([]);
	const [needReload, setNeedReload] = useState(true);
	const navigate = useNavigate();

	useEffect(() => {
		const getInmuebles = async () => {
			setNeedReload(false);
			const auxInmuebles = await getInmueblesByCliente(cliente);
			setInmuebles(auxInmuebles);
		};
		needReload && cliente && getInmuebles();
	}, [needReload, cliente]);

	return (
		<Box p={8} border='1px' rounded='md' shadow='dark-lg'>
			<Heading textAlign='center' mb={4}>
				Inmuebles
			</Heading>
			<Flex mt={-14}>
				<Spacer />
				<Button
					rounded='none'
					colorScheme='blue'
					onClick={() => navigate(`/inmuebles/crear/${cliente}`)}
				>
					<AddIcon />
				</Button>
			</Flex>
			<TableContainer maxH='40rem' overflowY='auto'>
				<Table size='sm'>
					<Thead>
						<Tr>
							<Th>Inmueble</Th>
							<Th>Estado</Th>
							<Th>Tipología</Th>
							<Th>Cliente</Th>
							<Th>Responsable</Th>
							<Th>Fecha insercción</Th>
							<Th>Fecha modificación</Th>
						</Tr>
					</Thead>
					<Tbody>
						{inmuebles && inmuebles.length === 0 && (
							<Tr>
								<Td
									colSpan={7}
									textAlign='center'
									fontWeight='bolder'
								>
									No hay inmuebles
								</Td>
							</Tr>
						)}
						{inmuebles &&
							inmuebles.length > 0 &&
							inmuebles.map(inmueble => (
								<InmuebleTableItem
									key={inmueble.uuid}
									inmueble={inmueble}
								/>
							))}
					</Tbody>
				</Table>
			</TableContainer>
		</Box>
	);
};

export default TablaInmueblesCliente;
